import React from 'react';
import Reflux from 'reflux';
import { Row, Col } from 'bootstrap';
import EventShowListStore from 'flux/stores/EventShowListStore';
import EventShowListActions from 'flux/actions/EventShowListActions';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import RouteActions from 'flux/actions/RouteActions';
import ConfirmActions from 'flux/actions/ConfirmActions';
import { WithTooltip } from '@shoflo-rundown/polymer.legacy';
import TooltipConstants from 'shared/constants/TooltipConstants.jsx';
import { List } from 'immutable';

/**
 * Show List
 *
 */
export default React.createClass({
  mixins: [Reflux.connect(EventShowListStore, 'singleEvent')],

  displayName: 'SingleEventSavedShowsList',

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  render() {
    let listItems = this.state.singleEvent.get('savedShows');
    let listItemNodes = listItems.size
      ? listItems.filter((item) => {
          if (this.props.type && this.props.type !== item.get('displayType'))
            return false;
          return item;
        })
      : List();

    return listItemNodes.size > 0 ? (
      <div className="text-list">
        {listItemNodes.map((item, i) => this._getItemNode(item, i))}
      </div>
    ) : (
      this._getNoneNode()
    );
  },

  _getNoneNode() {
    return (
      <Row>
        <Col lgOffset={1} lg={20}>
          <em>You have no saved versions.</em>
        </Col>
      </Row>
    );
  },

  _getItemNode(item) {
    return (
      <Row className="archived-show-list-item">
        <Col lg={11} md={16} sm={16} xs={16}>
          <WithTooltip placement="top" tip={TooltipConstants.CSSavedVsTitle}>
            <a onClick={() => this._handleTitleClick(item)}>
              {item.get('title')}
            </a>
          </WithTooltip>
        </Col>
        <Col lg={6} sm={8} xs={8}>
          {this._getIconBarNode(item)}
        </Col>
      </Row>
    );
  },

  _handleTitleClick(item) {
    let { teamId, eventId } = this.context.router.state.params;
    RouteActions.goToShowDisplayType(
      { teamId, eventId, showId: item.get('_id') },
      item.get('displayType'),
    );
  },

  /*
   * TODO: Consolidate Icon bar functionality into a single helper file with
   * factory functions.
   */
  _getIconBarNode(item) {
    let { teamId, eventId } = this.context.router.state.params;

    //<<<<<<< HEAD
    return <IconBar item={item} teamId={teamId} eventId={eventId} />;

    /**
     * Saved due to a conflict that could not immediately be resolved...
     */

    //=======
    //    return (
    //      <div className="icon-bar">
    //        <WithTooltip
    //          placement="left"
    //          tip={TooltipConstants.CSSavedVsDuplicate}>
    //          <Icon onClick={() => this._handleCreateSavedVersionClick(teamId, eventId, item.get('_id'), item.get('displayType'))} name="copy" size={2}/>
    //        </WithTooltip>
    //        <Icon onClick={() => this._handleSoftDeleteClick(teamId, eventId, item.get('_id'), item.get('displayType'))} name="trash" size={2}/>
    //      </div>
    //    );
    //>>>>>>> dev
  },

  /**
   * Saved due to a conflict that could not immediately be resolved...
   */

  //<<<<<<< HEAD
  //
  //=======
  //  _handleCreateSavedVersionClick(teamId, eventId, showId, displayType) {
  //    ConfirmActions.prompt('Are you sure you want to create a ' + displayType + ' from this saved version?',
  //      () => EventShowListActions.createFromSavedVersion(teamId, eventId, showId, displayType));
  //  },
  //
  //  _handleSoftDeleteClick(teamId, eventId, showId, displayType) {
  //    ConfirmActions.prompt('Are you sure you want to delete this ' + displayType + '?',
  //      () => EventShowListActions.onSoftDeleteSaved(teamId, eventId, showId));
  //  }
  //>>>>>>> dev
});

/* eslint-disable react/prop-types */
export const IconBar = ({ teamId, eventId, item }) => {
  let deleteClickHandler = item.get('archived')
    ? _handleHardDeleteClick
    : _handleArchiveClick;

  let duplicateIconNode = null,
    restoreIconNode = null;

  if (item.get('archived')) {
    restoreIconNode = (
      <Icon
        onClick={() =>
          _handleRestoreArchiveClick(teamId, eventId, item.get('_id'))
        }
        name="undo"
      />
    );
  } else {
    duplicateIconNode = (
      <WithTooltip placement="left" tip={TooltipConstants.CSSavedVsDuplicate}>
        <Icon
          onClick={() =>
            _handleCreateSavedVersionClick(
              teamId,
              eventId,
              item.get('_id'),
              item.get('displayType'),
            )
          }
          name="copy"
        />
      </WithTooltip>
    );
  }

  return (
    <div className="icon-bar">
      {restoreIconNode}
      {duplicateIconNode}
      <Icon
        onClick={() => deleteClickHandler(teamId, eventId, item.get('_id'))}
        name="trash"
      />
    </div>
  );
};
/* eslint-enable react/prop-types */

const _handleCreateSavedVersionClick = (
  teamId,
  eventId,
  showId,
  displayType,
) => {
  ConfirmActions.prompt(
    "This will place a copy of this show on your event's root folder.",
    () =>
      EventShowListActions.createFromSavedVersion(
        teamId,
        eventId,
        showId,
        displayType,
      ),
    'Create a new Show from Template',
  );
};

const _handleRestoreArchiveClick = (teamId, eventId, showId) => {
  ConfirmActions.prompt(
    'Are you sure you want to restore this saved version?',
    () => EventShowListActions.restoreTemplate(teamId, eventId, showId),
  );
};

const _handleArchiveClick = (teamId, eventId, showId) => {
  ConfirmActions.prompt(
    'Are you sure you want to delete this saved version?',
    () => EventShowListActions.archiveTemplate(teamId, eventId, showId),
  );
};

const _handleHardDeleteClick = (teamId, eventId, showId) => {
  ConfirmActions.prompt(
    'Are you sure you want to permanently delete this saved version?',
    () => EventShowListActions.hardDeleteSaved(teamId, eventId, showId),
  );
};
